import script from "./InteractionMessagesPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./InteractionMessagesPopover.vue?vue&type=script&setup=true&lang=js"

import "@/features/message/styles/InteractionMessagesPopover.css?vue&type=style&index=0&id=52679be0&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52679be0"]])

export default __exports__